<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-after: always;"></div>
<p class="P_Normal__And__Centre_Alignment__And__Left_Indent__And__Spacing_After__And__Tabs__And__Page_Break" id="auto_bookmark_toc_5"><span><img alt="LM-Prologue.jpg" src="image0.jpg" style=" padding-left: 3.10mm; padding-top: 0.00mm; padding-right: 3.10mm; padding-bottom: 0.00mm; width: 100%; max-width: 100%; max-height: 100%;"/></span></p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After"> </p>
<p class="P_Normal__And__Justification__And__Spacing_After" id="auto_bookmark_toc_4"><span style=" font-size: 0.93em;">COOL</span> and crisp, the air braced his skin as he took one last ride through the quiet roads, the purple and white speed demon between his legs begging to be let loose, allowed to zoom with all haste. Putting his head down, he let it fly, let himself feel the freedom of the wind and road. No one was there. He was alone and loving it. Tomorrow he’d do what his mother wanted and put the bike away, but today he’d soar on its wings of metal, rubber, and pumping pistons.</p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After">The sun felt glorious, bright, and full, warming his leather as the wind cooled it. Everything was perfect—he could ride like this forever.</p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After">The car appeared suddenly in front of him, and he slowed, humphing at the slowpoke. But it wasn’t moving. They weren’t moving. He heard the crunch of metal, the bang, a pop. Swerving, he tried to avoid them. Too late. For a second he thought he could fly and then pain, warm wetness, blindness—nothing.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0004.vue?1537279b